// Login Form Flip
$(document).ready(function () {
    $(".loginarea").flip({
        trigger: 'manual',
    });
    $(".forgotpasswordbtn").click(function () {
        $(".loginarea").flip(true);
    });
    $(".backtologinbtn").click(function () {
        $(".loginarea").flip(false);
    });
    $('.select-picker').selectpicker();
});
//# sourceMappingURL=custom.js.map